import React, { Fragment } from "react";
import CopyRight from "src/Components/Custom/CopyRight/CopyRight";
import Footer from "src/Components/Custom/Footer/Footer";
import UserNavBar from "src/Components/Custom/UserNavBar/UserNavBar";
import PrivacyContentEn from "./PrivacyContentEn";
import { useTranslation } from "react-i18next";
import PrivacyContentAr from "./PrivacyContentAr";
import PrivacyContentFr from "./PrivacyContentFr";

function AuthPrivacyPage() {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  return (
    <Fragment>
      <UserNavBar />
      {lang ==='ar'?<PrivacyContentAr/>:
      lang === 'fr' ? <PrivacyContentFr /> : <PrivacyContentEn />}
      <Footer />
      <CopyRight />
    </Fragment>
  );
}

export default AuthPrivacyPage;
